"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5336],{

/***/ 94131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18316);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var _floating_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85797);
/* harmony import */ var _floating_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42660);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32634);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83706);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var utils_style__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42812);







var CONTAINER_CLS = "";
var TOOLTIP_CLS = "rounded-md bg-gray-50 px-3 py-1.5 text-xs font-normal text-gray-600 shadow-lg ring-1 ring-gray-500/30 z-30";
var Tooltip = function(param) {
    var content = param.content, children = param.children, className = param.className, _tooltipOffset = param.tooltipOffset, tooltipOffset = _tooltipOffset === void 0 ? 5 : _tooltipOffset, tooltipClassName = param.tooltipClassName, _event = param.event, event = _event === void 0 ? "hover" : _event, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _delay = param.delay, delay = _delay === void 0 ? 800 : _delay;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useFloating */ .YF)({
        open: open,
        onOpenChange: setOpen,
        placement: "bottom-start",
        middleware: [
            (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .flip */ .RR)(),
            (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .offset */ .cv)(tooltipOffset),
            (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .shift */ .uY)()
        ]
    }), x = ref1.x, y = ref1.y, refs = ref1.refs, strategy = ref1.strategy, context = ref1.context;
    var ref2 = (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useInteractions */ .NI)([
        (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useHover */ .XI)(context, {
            delay: delay,
            enabled: event === "hover" && !disabled
        }),
        (0,_floating_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useClick */ .eS)(context, {
            enabled: event === "click" && !disabled
        }), 
    ]), getReferenceProps = ref2.getReferenceProps, getFloatingProps = ref2.getFloatingProps;
    var containerCls = (0,utils_style__WEBPACK_IMPORTED_MODULE_4__/* .calculateClasses */ .M)(className, CONTAINER_CLS);
    var tooltipCls = (0,utils_style__WEBPACK_IMPORTED_MODULE_4__/* .calculateClasses */ .M)(tooltipClassName, TOOLTIP_CLS);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                className: containerCls,
                ref: refs.setReference
            }, getReferenceProps()), {
                children: children
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_7__/* .Portal */ .h, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition */ .u, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                    show: open,
                    enter: "transition-opacity duration-75",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "transition-opacity duration-150",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    ref: refs.setFloating,
                    style: {
                        position: strategy,
                        top: y !== null && y !== void 0 ? y : 0,
                        left: x !== null && x !== void 0 ? x : 0
                    },
                    className: tooltipCls
                }, getFloatingProps()), {
                    children: content
                }))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Tooltip);


/***/ }),

/***/ 3539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$F": function() { return /* binding */ findPlan; },
/* harmony export */   "$m": function() { return /* binding */ useSubscriptionPayment; },
/* harmony export */   "CW": function() { return /* binding */ getIntentByInvoiceStatus; },
/* harmony export */   "LD": function() { return /* binding */ useUsageSummary; },
/* harmony export */   "MZ": function() { return /* binding */ useDefaultPaymentInfo; },
/* harmony export */   "Vu": function() { return /* binding */ useSubscriptionInfo; },
/* harmony export */   "_8": function() { return /* binding */ useCurrentUsage; },
/* harmony export */   "cA": function() { return /* binding */ usePaymentUpdate; },
/* harmony export */   "gG": function() { return /* binding */ useInvoicePreview; },
/* harmony export */   "qx": function() { return /* binding */ useInvoices; },
/* harmony export */   "rn": function() { return /* binding */ useProducts; }
/* harmony export */ });
/* unused harmony exports useAllSubscriptionInfo, useUsage, findFreeTrial */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29452);
/* harmony import */ var _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14498);
/* harmony import */ var _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83094);
/* harmony import */ var common_const__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29425);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16747);
/* harmony import */ var _useOrganizations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47427);






var useProducts = function() {
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)([
        api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.fetchProducts.url */ .X9.billing.fetchProducts.url
    ], (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data, starterPriceIds, proPriceIds, premiumPriceIds;
        return _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.fetchProducts */ .X9.billing.fetchProducts);
                case 2:
                    data = _ctx.sent.data;
                    starterPriceIds = [];
                    proPriceIds = [];
                    premiumPriceIds = [];
                    data.forEach(function(prd) {
                        prd.prices.forEach(function(price) {
                            if (price.name.startsWith(common_const__WEBPACK_IMPORTED_MODULE_2__/* .STARTER_SUBS */ .qb)) {
                                starterPriceIds.push(price.id);
                            }
                            if (price.name.startsWith(common_const__WEBPACK_IMPORTED_MODULE_2__/* .PRO_SUBS */ .D_)) {
                                proPriceIds.push(price.id);
                            }
                            if (price.name.startsWith(common_const__WEBPACK_IMPORTED_MODULE_2__/* .PREMIUM_SUBS */ .XI)) {
                                premiumPriceIds.push(price.id);
                            }
                        });
                        return prd.prices.find(function(price) {
                            return price.name.startsWith(common_const__WEBPACK_IMPORTED_MODULE_2__/* .STARTER_SUBS */ .qb);
                        });
                    });
                    return _ctx.abrupt("return", {
                        data: data,
                        starterPriceIds: starterPriceIds,
                        proPriceIds: proPriceIds,
                        premiumPriceIds: premiumPriceIds
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), common_const__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_SWR_OPTS_REFRESH_SLOW */ .tl), data = ref.data, error = ref.error, mutate = ref.mutate;
    var ref1, ref2, ref3;
    return {
        data: data === null || data === void 0 ? void 0 : data.data,
        starterPriceIds: (ref1 = data === null || data === void 0 ? void 0 : data.starterPriceIds) !== null && ref1 !== void 0 ? ref1 : [],
        proPriceIds: (ref2 = data === null || data === void 0 ? void 0 : data.proPriceIds) !== null && ref2 !== void 0 ? ref2 : [],
        premiumPriceIds: (ref3 = data === null || data === void 0 ? void 0 : data.premiumPriceIds) !== null && ref3 !== void 0 ? ref3 : [],
        isLoading: !error && !data,
        isError: error,
        mutate: mutate
    };
};
var useSubscriptionInfo = function() {
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.fetchSubInfo.url */ .X9.billing.fetchSubInfo.url, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.fetchSubInfo */ .X9.billing.fetchSubInfo);
                case 3:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data.sort(function(a, b) {
                        return a.createTime > b.createTime ? -1 : 1;
                    }));
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    if (!(_ctx.t0.status === 404)) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", [
                        null
                    ]);
                case 13:
                    throw _ctx.t0;
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    })), common_const__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_SWR_OPTS_REFRESH */ .oo), data = ref.data, error = ref.error, mutate = ref.mutate;
    var subsInfo = undefined;
    var pendingSubsInfo = undefined;
    if (Array.isArray(data)) {
        var ref1, ref2;
        if (data.length === 2) {
            subsInfo = data[1];
            pendingSubsInfo = data[0];
        } else if (((ref1 = data[0]) === null || ref1 === void 0 ? void 0 : ref1.subscriptionStatus) === common_const__WEBPACK_IMPORTED_MODULE_2__/* .SubscriptionStatus.INCOMPLETE */ .yh.INCOMPLETE || ((ref2 = data[0]) === null || ref2 === void 0 ? void 0 : ref2.subscriptionStatus) === common_const__WEBPACK_IMPORTED_MODULE_2__/* .SubscriptionStatus.PAST_DUE */ .yh.PAST_DUE) {
            pendingSubsInfo = data[0];
            subsInfo = data[0];
        } else {
            subsInfo = data[0];
        }
    }
    return {
        subsInfo: subsInfo,
        pendingSubsInfo: pendingSubsInfo,
        data: data,
        isLoading: !error && data === undefined,
        isError: error,
        isStarter: (subsInfo === null || subsInfo === void 0 ? void 0 : subsInfo.priceName) === common_const__WEBPACK_IMPORTED_MODULE_2__/* .STARTER_SUBS */ .qb,
        mutate: mutate
    };
// if (Array.isArray(data)) {
//   return {
//     data: data.sort((a, b) => (a.createTime > b.createTime ? -1 : 1)),
//     isLoading: !error && data === undefined,
//     isError: error,
//     mutate,
//   };
// } else {
//   return {
//     data: data,
//     isLoading: !error && data === undefined,
//     isError: error,
//     mutate,
//   };
// }
};
var useAllSubscriptionInfo = function() {
    var ref = useSWR(apiList.billing.fetchAllSubInfo.url, _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api(apiList.billing.fetchAllSubInfo);
                case 3:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", []);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    })), DEFAULT_SWR_OPTS_REFRESH), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        data: data,
        isLoading: !error && data === undefined,
        isError: error,
        mutate: mutate
    };
};
var useSubscriptionPayment = function() {
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.fetchPaymentInfo.url */ .X9.billing.fetchPaymentInfo.url, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.fetchPaymentInfo */ .X9.billing.fetchPaymentInfo, {});
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), common_const__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_SWR_OPTS */ .g0), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        data: data,
        isLoading: !error && !data,
        isError: error,
        mutate: mutate
    };
};
var usePaymentUpdate = function() {
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.updatePayment.url */ .X9.billing.updatePayment.url, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.updatePayment */ .X9.billing.updatePayment, {});
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), common_const__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_SWR_OPTS */ .g0), data = ref.data, error = ref.error;
    return {
        data: data,
        isLoading: !error && !data,
        isError: error
    };
};
var useDefaultPaymentInfo = function() {
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.defaultPaymentInfo.url */ .X9.billing.defaultPaymentInfo.url, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.defaultPaymentInfo */ .X9.billing.defaultPaymentInfo, {});
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), common_const__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_SWR_OPTS */ .g0), data = ref.data, error = ref.error;
    return {
        data: data,
        isLoading: !error && !data,
        isError: error
    };
};
var useUsageSummary = function() {
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.fetchUsage.url */ .X9.billing.fetchUsage.url, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.fetchUsageSummary */ .X9.billing.fetchUsageSummary, {});
                case 3:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    if (!(_ctx.t0.status === 404)) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 13:
                    throw _ctx.t0;
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    })), common_const__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_SWR_OPTS_FASTER */ .Od), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        data: data,
        isLoading: !error && !data,
        isError: error,
        mutate: mutate
    };
};
var useUsage = function(start, end) {
    var ref = useSWR([
        apiList.billing.fetchUsage.url,
        start,
        end
    ], _async_to_generator(regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return api(apiList.billing.fetchUsage, {
                        start: start,
                        end: end
                    });
                case 3:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", []);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    })), DEFAULT_SWR_OPTS), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        data: data,
        isLoading: !error && data === undefined,
        isError: error,
        mutate: mutate
    };
};
var useCurrentUsage = function(pagination) {
    var organization = (0,_useOrganizations__WEBPACK_IMPORTED_MODULE_4__/* .useCurrentOrg */ .X6)().organization;
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)([
        api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.fetchUsage.url */ .X9.billing.fetchUsage.url,
        organization === null || organization === void 0 ? void 0 : organization.id,
        pagination.page,
        pagination.size, 
    ], (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.fetchUsage */ .X9.billing.fetchUsage, {
                        organizationId: organization === null || organization === void 0 ? void 0 : organization.id,
                        page: pagination.page,
                        size: pagination.size
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), common_const__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_SWR_OPTS */ .g0), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        data: data,
        isLoading: !error && !data,
        isError: error,
        mutate: mutate
    };
};
var useInvoices = function(params) {
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)([
        api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.fetchInvoice.url */ .X9.billing.fetchInvoice.url,
        params ? JSON.stringify(params) : ""
    ], (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.fetchInvoice */ .X9.billing.fetchInvoice, {
                        limit: 10,
                        startAfter: params === null || params === void 0 ? void 0 : params.startAfter,
                        endingBefore: params === null || params === void 0 ? void 0 : params.endingBefore
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), common_const__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_SWR_OPTS */ .g0), data = ref.data, error = ref.error;
    var hasPrevious = false;
    var hasNext = false;
    if ((params === null || params === void 0 ? void 0 : params.startAfter) && !(params === null || params === void 0 ? void 0 : params.endingBefore)) {
        hasNext = Boolean(data === null || data === void 0 ? void 0 : data.hasMore);
        hasPrevious = true;
    }
    if (!(params === null || params === void 0 ? void 0 : params.startAfter) && (params === null || params === void 0 ? void 0 : params.endingBefore)) {
        hasPrevious = Boolean(data === null || data === void 0 ? void 0 : data.hasMore);
        hasNext = true;
    }
    if (!params) {
        hasNext = Boolean(data === null || data === void 0 ? void 0 : data.hasMore);
    }
    return {
        data: data,
        hasPrevious: hasPrevious,
        hasNext: hasNext,
        isLoading: !error && !data,
        isError: error
    };
};
var useInvoicePreview = function(priceId) {
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)([
        api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.invoicePreview.url */ .X9.billing.invoicePreview.url,
        priceId
    ], (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _home_runner_work_metascan_metascan_frontend_node_modules_pnpm_next_12_2_4_babel_core_7_19_6_react_dom_18_2_0_react_18_2_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!priceId) {
                        _ctx.next = 5;
                        break;
                    }
                    _ctx.next = 3;
                    return (0,api__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(api__WEBPACK_IMPORTED_MODULE_1__/* .apiList.billing.invoicePreview */ .X9.billing.invoicePreview, {
                        priceId: priceId
                    });
                case 3:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), common_const__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_SWR_OPTS_REFRESH */ .oo), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        data: data,
        isLoading: !error && !data,
        isError: error,
        mutate: mutate
    };
};
var findPlan = function(priceId, products) {
    if (!priceId || !products) {
        return {
            plan: undefined,
            price: undefined
        };
    }
    var plan = products.find(function(product) {
        return product.prices.some(function(price) {
            return price.id === priceId;
        });
    });
    var price = plan === null || plan === void 0 ? void 0 : plan.prices.find(function(prices) {
        return prices.id === priceId;
    });
    return {
        plan: plan,
        price: price
    };
};
var findFreeTrial = function(products) {
    var plan = products.find(function(product) {
        return product.projectType === "free";
    });
    var price = plan === null || plan === void 0 ? void 0 : plan.prices[0];
    return {
        plan: plan,
        price: price
    };
};
var getIntentByInvoiceStatus = function(status) {
    switch(status){
        case "draft":
            return "secondary";
        case "open":
            return "info";
        case "paid":
            return "success";
        case "uncollectible":
            return "error";
    }
};


/***/ })

}]);